import React, { useState } from 'react';
import { Button, Icon } from 'components/atoms';
import styled from 'styled-components/macro';
import { Popover } from 'components/molecules';
import PropTypes from 'prop-types';
import { iconType } from 'types';
import { generateKey } from 'services/generators'

const PopoverActions = ({
  actions,
  disabled,
  iconHeight,
  buttonModifiers,
  handler,
  ...props
}) => {
  const [triggerClose, setTriggerClose] = useState(false)

  if (disabled) {
    return (
      <Button modifiers={['invisible', 'fixSpacing']} loading>
        <Icon icon="more-horiz" height={iconHeight} />
      </Button>
    )
  }

  const handleActionClick = (onClick) => {
    setTriggerClose(!triggerClose)
    onClick()
  }

  return (
    <Popover
      content={(
        <Actions>
          {actions.map(({
            icon = null, text, onClick, isLoading = false, disabled = false
          }, index) => (
            <Button
              key={generateKey(index)}
              icon={icon}
              disabled={disabled}
              modifiers={['bottomBorder', (disabled ? 'disabled' : 'active')]}
              onClick={() => handleActionClick(onClick)}
              isLoading={isLoading}
            >
              {text}
            </Button>
          ))}
        </Actions>
      )}
      triggerClose={triggerClose}
      {...props}
    >
      {handler || (
        <Button modifiers={['invisibleWithHover', 'xs3', ...buttonModifiers]} aria-label="ver ações">
          <Icon icon="more-horiz" height={iconHeight} />
        </Button>
      )}
    </Popover>
  );
}

const Actions = styled.div`
  display: flex;
  flex-direction: column;
`;

PopoverActions.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    onClick: PropTypes.func,
    icon: iconType,
    disabled: PropTypes.bool,
    isLoading: PropTypes.bool,
  })),
  position: PropTypes.oneOf(['top', 'bottom', 'right', 'left']),
  iconHeight: PropTypes.number,
  disabled: PropTypes.bool,
  buttonModifiers: PropTypes.arrayOf(PropTypes.string),
  handler: PropTypes.node,
};

PopoverActions.defaultProps = {
  actions: [],
  position: 'bottom',
  iconHeight: 24,
  disabled: false,
  buttonModifiers: [],
  handler: null,
};

export default PopoverActions;
